import React from 'react';
import styles from './TextLimitHint.module.scss';

interface TextLimitHintProps {
  value?: string | null;
  max: number;
}

/** "120 / 1000" under a text field; turns amber close to the limit. */
const TextLimitHint: React.FC<TextLimitHintProps> = ({ value, max }) => {
  const length = value?.length ?? 0;
  return (
    <span className={`${styles.hint} ${length >= max * 0.9 ? styles.near : ''}`}>
      {length} / {max}
    </span>
  );
};

export default TextLimitHint;
